import React from 'react'

function AC_program_details() {
  return (
    <div>
      {/* --------------------Mobile View----------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-6">
                  AutoCAD Mastery: Blueprint for Success!
                </h1>
                <p className="py-2">
                  Unlock the power of design with our AutoCAD course. Enrol now
                  to shape your skills, forge a path to excellence, and
                  illuminate your future in design engineering!
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Learn AutoCAD from the ground up with our engaging course
                  materials. Our training covers all the bases, from geometry
                  creation and advanced features to parametric restrictions and
                  dynamic blocks. Dive into AutoCAD 2023, studying its user
                  interfaces and advanced features. Autodesk Inventor is a
                  powerful tool for learning sheet metal design, assembly
                  methods, and sketching. Cap it off with real-world application
                  through little and major projects, developing practical skills
                  for a successful career in CAD design and engineering.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className=" Details_container shadow-lg px-1 py-4">
                  <h1 className="Details_text text-center  pb-2 border-bottom">
                    AutoCAD
                  </h1>
                  <div className="Details_text">
                    <ul className="pt-2">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------Desktop View-------------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h1 className="fs-2">
                  AutoCAD Mastery: Blueprint for Success!
                </h1>
                <p className="py-2">
                  Unlock the power of design with our AutoCAD course. Enrol now
                  to shape your skills, forge a path to excellence, and
                  illuminate your future in design engineering!
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Learn AutoCAD from the ground up with our engaging course
                  materials. Our training covers all the bases, from geometry
                  creation and advanced features to parametric restrictions and
                  dynamic blocks. Dive into AutoCAD 2023, studying its user
                  interfaces and advanced features. Autodesk Inventor is a
                  powerful tool for learning sheet metal design, assembly
                  methods, and sketching. Cap it off with real-world application
                  through little and major projects, developing practical skills
                  for a successful career in CAD design and engineering.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h1 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    AutoCAD
                  </h1>
                  <div className="Details_text ">
                    <ul className="pt-3">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AC_program_details
